document.addEventListener('DOMContentLoaded', () => {
  const carousels = document.querySelectorAll('.product-card-carousel');

  carousels.forEach(carousel => {
    const mainImage = carousel.querySelector('.carousel-main-img');
    const thumbnails = Array.from(carousel.querySelectorAll('.carousel-thumbnail'));
    const prevBtn = carousel.querySelector('.carousel-arrow-left');
    const nextBtn = carousel.querySelector('.carousel-arrow-right');

    if (!mainImage || thumbnails.length === 0) return;

    let currentIndex = thumbnails.findIndex(t => t.classList.contains('active'));
    if (currentIndex === -1) currentIndex = 0;

    function setImage(index) {
      const thumb = thumbnails[index];
      const fullSrc = thumb.getAttribute('data-full-src') || thumb.src;

      mainImage.src = fullSrc;
      mainImage.srcset = ''; // optional: keep simple

      thumbnails.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');

      currentIndex = index;
    }

    // Thumbnail clicks
    thumbnails.forEach((thumb, idx) => {
      thumb.addEventListener('click', () => setImage(idx));
    });

    // Arrows
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        const newIndex = (currentIndex - 1 + thumbnails.length) % thumbnails.length;
        setImage(newIndex);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        const newIndex = (currentIndex + 1) % thumbnails.length;
        setImage(newIndex);
      });
    }
  });
});

// Nov 2026: clicking a product card's photo opens the product page (same link as the product name).
(function () {
  const style = document.createElement('style');
  style.textContent = '.product-card-carousel .carousel-main-img{cursor:pointer}';
  document.head.appendChild(style);

  document.addEventListener('click', (event) => {
    const image = event.target.closest('.product-card-carousel .carousel-main-img');
    if (!image) return;
    const card = image.closest('.card-wrapper');
    const link = card && card.querySelector('.card__heading a[href]');
    if (!link) return;
    event.preventDefault();
    if (event.metaKey || event.ctrlKey || event.shiftKey) {
      window.open(link.href, '_blank');
    } else {
      window.location.href = link.href;
    }
  });
})();
